import type { ITreeNode } from './types';

/** Flattens the tree into a `fileId → node` lookup map. */
export function indexFiles(nodes: ITreeNode[]): Map<string, ITreeNode> {
  const map = new Map<string, ITreeNode>();
  const walk = (list: ITreeNode[]) => {
    for (const n of list) {
      if (n.kind === 'file' && n.fileId) map.set(n.fileId, n);
      if (n.children) walk(n.children);
    }
  };
  walk(nodes);
  return map;
}

/**
 * Ancestor chain (root → … → the file itself) for the breadcrumb row, resolved
 * by walking the tree down from the roots. There is no stored display-path on
 * a node — it is deliberately derived from the hierarchy instead (see
 * PLAN-library-integration.md, Faza 2).
 */
export function findNodePath(nodes: ITreeNode[], fileId: string): ITreeNode[] | null {
  const walk = (list: ITreeNode[], trail: ITreeNode[]): ITreeNode[] | null => {
    for (const n of list) {
      const next = [...trail, n];
      if (n.kind === 'file' && n.fileId === fileId) return next;
      if (n.children) {
        const found = walk(n.children, next);
        if (found) return found;
      }
    }
    return null;
  };
  return walk(nodes, []);
}
